import { render, staticRenderFns } from "./dumpling.vue?vue&type=template&id=393b7836&scoped=true&"
import script from "./dumpling.vue?vue&type=script&lang=js&"
export * from "./dumpling.vue?vue&type=script&lang=js&"
import style0 from "./dumpling.vue?vue&type=style&index=0&id=393b7836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393b7836",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('393b7836')) {
      api.createRecord('393b7836', component.options)
    } else {
      api.reload('393b7836', component.options)
    }
    module.hot.accept("./dumpling.vue?vue&type=template&id=393b7836&scoped=true&", function () {
      api.rerender('393b7836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/ActivePages/dumpling.vue"
export default component.exports